import { isLoyaltyPurchasePointsItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'

export const isStandaloneLoyaltyPurchasePoints = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => !!items.length && items.every(isLoyaltyPurchasePointsItem),
)

export const isLoyaltyPurchasePointsInCart = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => items.some(isLoyaltyPurchasePointsItem),
)
